export enum NewsletterStates {
  SENT = 'sent',
  SCHEDULED = 'scheduled',
  DRAFT = 'draft',
}

export interface NewsletterAttributes {
  id: string;
  subject: string;
  letter: string;
  scheduled_at: string;
  state: NewsletterStates;
  created_at: string;
  updated_at: string;
  sent_at: string;
  opened: number;
  clicks: number;
  images: Images;
  letter_html: string;
  recipient_count: number;
  schedule_at_timezone: string;
  schedule_at_in_timezone: string;
  touchpoint_ids: string[];
}

export interface Images {
  data: Array<{
    id: string;
    type: string;
    attributes: ImagesAttributes;
  }>;
}
export interface UploadImageResponse {
  data: {
    id: string;
    type: string;
    attributes: {
      id: number;
      record_id: string;
      record_type: string;
      url: string;
    };
  };
}

export interface ImagesAttributes {
  id: number;
  record_id: string;
  record_type: string;
  url: string;
}

export interface Newsletter {
  id: string;
  type: 'news_letter';
  attributes: NewsletterAttributes;
}

export interface NewsletterResponse {
  data: Newsletter;
}

export interface NewslettersResponse {
  data: Newsletter[];
  meta: {
    total: number;
    count_mapping: Record<string, number>;
  };
}

export interface NewsletterCreate {
  subject?: string;
  letter?: string;
  state?: string;
  letter_html?: string;
  hidden?: boolean;
  scheduled_at?: string | null;
  send_now?: boolean;
  schedule_at_timezone?: string;
  touchpoint_ids?: string[];
}
